export default __webpack_public_path__ + "static/partner-tube-5-14d3ea03be613810df4672a7f0b4f79a.png";